<script setup lang="ts">
import BottomSheetDialog from '@/components/Utilities/BottomSheetDialog.vue';
import type { Question } from '@/types/TestReview';
import TestQuestionList from '@/components/Student/TestReview/TestQuestionList.vue';

defineProps<{
    questionIndex: number;
    questions: Question[];
}>();

</script>
<template>
    <BottomSheetDialog
        ref="dialogRef"
        full-width
        title="Select a question"
        :enable-clear-all-btn="false"
        :enable-action-btns="false"
    >
        <TestQuestionList
            :questions="questions"
        />
    </BottomSheetDialog>
</template>
<style scoped>
</style>
